import { render, staticRenderFns } from "./BranchDetailPage.vue?vue&type=template&id=38df94d4&"
import script from "./BranchDetailPage.vue?vue&type=script&lang=js&"
export * from "./BranchDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports